import * as React from 'react';
import { SVGProps } from 'react';

const IconBitSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17 4H7v3.25L4 8v7l-2 1a4 4 0 0 0 4 4h.333L7 18h3l.667 2h2.666L14 18h3l.667 2H18a4 4 0 0 0 4-4l-2-1V8l-3-.75V4Z" />
  </svg>
);
export default IconBitSizeM;
